export default __webpack_public_path__ + "static/media/onboarding-event-list.dcf935aa.gif";